export default __webpack_public_path__ + "static/media/mint_extlink.6ea135e9.svg";